import { useMemo, useEffect } from 'react';

import { useAtom } from 'jotai';

import { ErorrsAtom, SuccessAtom } from '@/lib/store';
import FeedbackMessage, { FeedbackType } from '@/tayara-kit/FeedbackMessage';

const useDisplayMessage = (
  currentTabKey: string | undefined,
  pageName: string
) => {
  const [errors, updateErrors] = useAtom(ErorrsAtom);
  const [successs, updateSuccess] = useAtom(SuccessAtom);

  const DisplayError = useMemo(
    () =>
      currentTabKey &&
      errors[`${pageName}_${currentTabKey}`] && (
        <FeedbackMessage
          type={FeedbackType.NEGATIVE}
          text={errors[`${pageName}_${currentTabKey}`] || ''}
        />
      ),
    [errors, currentTabKey, pageName]
  );

  const DisplaySuccess = useMemo(
    () =>
      currentTabKey &&
      successs[`${pageName}_${currentTabKey}`] && (
        <FeedbackMessage
          type={FeedbackType.POSITIVE}
          text={successs[`${pageName}_${currentTabKey}`] || ''}
        />
      ),
    [successs, currentTabKey, pageName]
  );

  // init all error and success message when tab change
  useEffect(() => {
    const initMessages = () => {
      updateErrors({
        type: 'init',
        tabName: '',
        message: '',
      });
      updateSuccess({ type: 'init', tabName: '', message: '' });
    };
    initMessages();
  }, [currentTabKey, updateSuccess, updateErrors]);

  return [DisplaySuccess, DisplayError];
};

export default useDisplayMessage;
